import React from "react";
import { getIipayFasciaLabel } from "../utils/iipayFascia";

export const IipayFasciaBadge = ({ row }) => {
  const label = getIipayFasciaLabel(row);
  if (!label) return null;
  return <span title={`Fascia iiPay applicata: ${label}`}
    className="inline-flex w-32 shrink-0 justify-center whitespace-nowrap rounded border border-blue-200 bg-blue-50 px-1.5 py-0.5 text-[10px] font-semibold text-blue-700">
    A fascia {label}
  </span>;
};
